// ADR 16.10.26f §5 — the one eager entry to the install guide. It works out
// the variant and renders the lazy stepper for one `GUIDED` names, else
// 16.10.26b's sentence dialog — iOS only, since `mac_safari` is always guided.
// It reads the guided *names* from `guideVariants.ts` and never imports
// `guides.ts` or `scenes/`, which would fold the guide into the boot chunk
// (§7, pinned by AC3's source walk). The `Suspense` fallback is `null`: on a
// first visit the tap shows nothing for one round trip (Consequences).
//
// Must not import the wasm facade: it is in 25.9.26f's boot graph.

import { lazy, Suspense } from 'react'

import { IosInstallDialog } from '../IosInstallDialog'
import { GUIDED } from './guideVariants'
import { guideVariantOf } from './variant'

const InstallGuideDialog = lazy(() => import('./InstallGuideDialog'))

export function InstallGuide({ platform, onClose }: { platform: 'ios' | 'mac_safari'; onClose(): void }) {
  const variant = guideVariantOf(platform, navigator.userAgent, navigator.maxTouchPoints ?? 0)
  if (platform === 'ios' && !GUIDED.has(variant)) return <IosInstallDialog onClose={onClose} />
  return (
    <Suspense fallback={null}>
      <InstallGuideDialog variant={variant} platform={platform} onClose={onClose} />
    </Suspense>
  )
}
